import Slideshow from "../components/Slideshow"
import Service from "../components/Service"

const HomePage = () => {
    return (
        <div>
            <Slideshow></Slideshow>
            <Service></Service>
        </div>
    )
};
export default HomePage;